import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Sandbox20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2.25H10.75V8H13.4999C13.4877 8.42404 13.4229 8.84386 13.3076 9.25H17.7366L15.5548 5.25H13V3.75H15.7032C16.1606 3.75 16.5815 3.99986 16.8006 4.40143L19.5974 9.52893C19.6975 9.71254 19.75 9.91835 19.75 10.1275V16.5C19.75 17.1904 19.1904 17.75 18.5 17.75H1.5C0.809645 17.75 0.25 17.1904 0.25 16.5V10.1275C0.25 9.91835 0.302479 9.71254 0.402631 9.52893L3.19945 4.40143C3.41849 3.99986 3.83939 3.75 4.29682 3.75H7.5V5.25H4.44522L2.26341 9.25H6.72219C6.60696 8.84386 6.54213 8.42404 6.52991 8H9.25V2.25H8V0.75H12V2.25ZM1.75 10.75V16.25H18.25V10.75L1.75 10.75Z'
      fill='currentColor'
    />
  </Svg>
);

Sandbox20.displayName = 'Sandbox20';
export default Sandbox20;
